import { Toast, toastDefaultTime } from './model'
import { AppAction, Dispatch, GetState } from '../../types'

export enum ActionType {
  ChangeToasts = 'Monitoring/Toasts/ChangeToasts'
}

// Basic Actions

export type ChangeToastsAction = {
  type: ActionType.ChangeToasts
  payload: { toasts: Toast[] }
}

export type MonitoringToastsAction =
  | ChangeToastsAction

// Basic Actions Creators

export const changeToastsAction = (toasts: Toast[]): AppAction => ({
  type: ActionType.ChangeToasts,
  payload: { toasts }
})

// Thunks

export const addToast = (toast: Toast) => (dispatch: Dispatch, getState: GetState) => {
  const toasts: Toast[] = getState().monitoring.toasts.toastList
  const newToastList = [...toasts]
  const toastTime = toast.time ? toast.time : toastDefaultTime

  if (newToastList.length === 0) {
    toast.id = 0
  } else {
    const lastId = newToastList[newToastList.length - 1].id
    toast.id = lastId ? lastId + 1 : 0
  }
  newToastList.push(toast)
  setTimeout(() => {
    dispatch(removeToast(toast.id ? toast.id : 0))
  },         toastTime)

  dispatch(changeToastsAction(newToastList))
}

export const removeToast = (id: number) => (dispatch: Dispatch, getState: GetState) => {
  const toasts: Toast[] = getState().monitoring.toasts.toastList
  const newToastList = toasts.filter(toast => toast.id !== id)

  dispatch(changeToastsAction(newToastList))
}
